import Header from '@/components/header/Header.vue';
import Footer from '@/components/footer/Footer.vue';
import OldBookQuickDrawer from '@/components/old-book-quick-drawer/OldBookQuickDrawer.vue';
import axios from '@/config/axios';

export default {
  name: 'MyOldBookList',
  components: {
    Header,
    Footer,
    OldBookQuickDrawer
  },
  data() {
    return {
      booths: [],
      searchKeyword: '',
      selectedStatus: null,
      currentPage: 0,
      totalPages: 0,
      totalElements: 0,
      statusCounts: { all: 0, '0': 0, '1': 0, '2': 0, '3': 0, '4': 0 },
      searchDebounceTimeout: null,
      isLoading: false,

      // Quick View Drawer & Zoom State
      drawerBooth: null,
      drawerActiveImg: null,
      showZoomModal: false,
      zoomScale: 1,
      zoomPanX: 0,
      zoomPanY: 0,
      isDragging: false,
      dragStartX: 0,
      dragStartY: 0,
      toolbarHidden: false
    };
  },
  computed: {
    isLoggedIn() {
      return !!localStorage.getItem('token');
    },
    filteredBooths() {
      return this.booths;
    },
    visiblePages() {
      const current = this.currentPage;
      const total = this.totalPages;
      if (total <= 7) return Array.from({ length: total }, (_, i) => i);

      const pages = [0];
      const start = Math.max(1, current - 1);
      const end = Math.min(total - 2, current + 1);

      if (start > 1) pages.push('...');
      for (let i = start; i <= end; i++) pages.push(i);
      if (end < total - 2) pages.push('...');
      pages.push(total - 1);
      
      return pages;
    }
  },
  watch: {
    searchKeyword() {
      if (this.searchDebounceTimeout) clearTimeout(this.searchDebounceTimeout);
      this.searchDebounceTimeout = setTimeout(() => {
        this.fetchMyBooths(0);
      }, 350);
    },
    showZoomModal(open) {
      if (open) {
        document.body.style.overflow = 'hidden';
        window.addEventListener('keydown', this.handleZoomKeydown);
      } else {
        document.body.style.overflow = '';
        window.removeEventListener('keydown', this.handleZoomKeydown);
      }
    }
  },
  mounted() {
    if (!this.isLoggedIn) {
      this.$toast.error('Vui lòng đăng nhập để xem danh sách gian hàng của bạn!');
      this.$router.push('/login');
      return;
    }
    this.fetchMyBooths(0);
  },
  methods: {
    filterStatus(status) {
      if (this.selectedStatus === status) return;
      this.selectedStatus = status;
      this.fetchMyBooths(0);
    },
    fetchMyBooths(page) {
      if (page < 0 || (this.totalPages > 0 && page >= this.totalPages)) return;
      
      this.isLoading = true;
      let url = `/old-book/my-books?page=${page}`;
      if (this.selectedStatus !== null && this.selectedStatus !== undefined) {
        url += `&status=${this.selectedStatus}`;
      }
      if (this.searchKeyword && this.searchKeyword.trim()) {
        url += `&key=${encodeURIComponent(this.searchKeyword.trim())}`;
      }

      axios.get(url)
        .then(res => {
          if (res.data.status === '200') {
            const result = res.data.result;
            const pageData = result.page || result;
            const items = pageData.content || [];

            if (result.statusCounts) {
              this.statusCounts = result.statusCounts;
            }

            const isValidImg = (val) => {
              if (!val || typeof val !== 'string') return false;
              const trimmed = val.trim();
              return trimmed !== '' && trimmed !== 'null' && trimmed !== 'undefined' && trimmed !== 'NaN';
            };

            this.booths = items.map(item => {
              ['stackImage', 'coverImage'].forEach(k => {
                if (!isValidImg(item[k])) {
                  item[k] = null;
                } else if (!item[k].startsWith('data:') && !item[k].startsWith('http')) {
                  item[k] = 'data:image/png;base64,' + item[k];
                }
              });
              if (item.books && Array.isArray(item.books)) {
                item.books.forEach(b => {
                  ['cover', 'coverBack'].forEach(k => {
                    if (!isValidImg(b[k])) {
                      b[k] = null;
                    } else if (!b[k].startsWith('data:') && !b[k].startsWith('http')) {
                      b[k] = 'data:image/png;base64,' + b[k];
                    }
                  });
                });
              }
              return item;
            });
            this.currentPage = pageData.number !== undefined ? pageData.number : page;
            this.totalPages = pageData.totalPages || 0;
            this.totalElements = pageData.totalElements || 0;
          } else {
            this.booths = [];
            this.totalPages = 0;
            this.totalElements = 0;
          }
        })
        .catch(err => {
          console.error(err);
          this.booths = [];
          this.totalPages = 0;
          this.totalElements = 0;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    changeStatus(booth, newStatus) {
      if (!booth || !booth.id) return;
      axios.put(`/old-book/status/${booth.id}`, { status: newStatus })
        .then(res => {
          if (res.data.status === '200') {
            this.$toast.success('Cập nhật trạng thái thành công!');
            booth.status = newStatus;
          } else {
            this.$toast.error(res.data.message || 'Cập nhật thất bại');
          }
        })
        .catch(err => {
          console.error(err);
          this.$toast.error('Lỗi khi cập nhật trạng thái');
        });
    },
    canEditBooth(booth) {
      if (!booth) return false;
      return booth.status !== 2 && booth.status !== 4;
    },
    openQuickView(booth) {
      this.drawerBooth = booth;
      this.drawerActiveImg = booth.coverImage || booth.stackImage || (booth.books && booth.books[0] && booth.books[0].cover) || null;
    },
    closeQuickView() {
      this.drawerBooth = null;
      this.drawerActiveImg = null;
    },
    getDrawerMediaList(booth) {
      if (!booth) return [];
      const list = [];
      if (booth.stackImage) {
        list.push({ url: booth.stackImage, label: 'Chồng sách' });
      }
      if (booth.books && Array.isArray(booth.books)) {
        booth.books.forEach((b, idx) => {
          if (b.cover) list.push({ url: b.cover, label: `C.${idx + 1} Bìa trước` });
          if (b.coverBack) list.push({ url: b.coverBack, label: `C.${idx + 1} Bìa sau` });
        });
      }
      return list;
    },
    getAuthorsList(booth) {
      if (!booth || !booth.books || !Array.isArray(booth.books)) return [];
      const names = [];
      booth.books.forEach(b => {
        if (b.author && b.author.trim() && !names.includes(b.author.trim())) {
          names.push(b.author.trim());
        }
      });
      return names;
    },
    getCategoriesList(booth) {
      if (!booth || !booth.books || !Array.isArray(booth.books)) return [];
      const catSet = new Set();
      booth.books.forEach(b => {
        if (b.categories) {
          try {
            const parsed = typeof b.categories === 'string' ? JSON.parse(b.categories) : b.categories;
            if (Array.isArray(parsed)) {
              parsed.forEach(c => {
                if (typeof c === 'string') catSet.add(c);
                else if (c && c.name) catSet.add(c.name);
              });
            }
          } catch (e) {
            // ignore
          }
        }
      });
      return Array.from(catSet);
    },
    getConditionLabel(verStatus) {
      const map = {
        0: 'Rất mới (95 - 100%)',
        1: 'Như mới (85 - 94%)',
        2: 'Khá mới (70 - 84%)',
        3: 'Trung bình (50 - 69%)',
        4: 'Cũ (< 50%)'
      };
      return map[verStatus] || 'Tốt';
    },
    formatDate(timeStr) {
      if (!timeStr || timeStr.length < 8) return '—';
      const y = timeStr.substring(0, 4);
      const m = timeStr.substring(4, 6);
      const d = timeStr.substring(6, 8);
      return `${d}/${m}/${y}`;
    },
    formatWeight(weight) {
      if (!weight) return '0g';
      if (weight >= 1000) {
        return (weight / 1000).toFixed(1).replace('.0', '') + ' kg';
      }
      return weight + 'g';
    },
    // Zoom Modal methods
    openZoomModal(img) {
      if (!img) return;
      this.drawerActiveImg = img;
      this.zoomScale = 1;
      this.zoomPanX = 0;
      this.zoomPanY = 0;
      this.showZoomModal = true;
    },
    closeZoomModal() {
      this.showZoomModal = false;
      this.zoomScale = 1;
      this.zoomPanX = 0;
      this.zoomPanY = 0;
    },
    zoomIn() {
      this.zoomScale = Math.min(4, +(this.zoomScale + 0.5).toFixed(1));
    },
    zoomOut() {
      this.zoomScale = Math.max(0.5, +(this.zoomScale - 0.5).toFixed(1));
      if (this.zoomScale <= 1) {
        this.zoomPanX = 0;
        this.zoomPanY = 0;
      }
    },
    resetZoom() {
      this.zoomScale = 1;
      this.zoomPanX = 0;
      this.zoomPanY = 0;
    },
    toggleDblZoom(e) {
      if (this.zoomScale > 1) {
        this.resetZoom();
      } else {
        this.zoomScale = 2;
      }
    },
    handleWheelZoom(e) {
      e.preventDefault();
      const delta = e.deltaY > 0 ? -0.2 : 0.2;
      const nextScale = Math.min(4, Math.max(0.5, +(this.zoomScale + delta).toFixed(2)));
      this.zoomScale = nextScale;
      if (nextScale <= 1) {
        this.zoomPanX = 0;
        this.zoomPanY = 0;
      }
    },
    handleZoomKeydown(e) {
      if (e.key === 'Escape') this.closeZoomModal();
      else if (e.key === '+' || e.key === '=') this.zoomIn();
      else if (e.key === '-' || e.key === '_') this.zoomOut();
      else if (e.key === '0') this.resetZoom();
    },
    startDrag(e) {
      if (this.zoomScale <= 1) return;
      this.isDragging = true;
      this.dragStartX = e.clientX - this.zoomPanX;
      this.dragStartY = e.clientY - this.zoomPanY;
    },
    onDrag(e) {
      if (!this.isDragging) return;
      this.zoomPanX = e.clientX - this.dragStartX;
      this.zoomPanY = e.clientY - this.dragStartY;
    },
    stopDrag() {
      this.isDragging = false;
    },
    goToCreateBook() {
      this.$router.push('/old-books/create');
    },
    goToEditBooth(booth) {
      if (booth && booth.id) {
        this.$router.push('/old-books/edit/' + booth.id);
      }
    },
    goToDetail(id) {
      this.$router.push('/old-books/' + id);
    },
    getCoverUrl(path) {
      const defaultPlaceholder = "data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='160' viewBox='0 0 120 160'%3E%3Crect width='100%25' height='100%25' fill='%23f5f2ea'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' fill='%23b5b0a5' font-family='sans-serif' font-size='14'%3EGian H%C3%A0ng%3C/text%3E%3C/svg%3E";
      if (!path || typeof path !== 'string') return defaultPlaceholder;
      if (path.startsWith('http://') || path.startsWith('https://') || path.startsWith('data:') || path.startsWith('blob:')) {
        return path;
      }
      if (!path.includes('/') && !path.includes('\\') && !path.includes(':')) {
        return 'data:image/jpeg;base64,' + path;
      }

      let cleanPath = path.replace(/\\/g, '/');
      if (cleanPath.includes('oldbooks/')) {
        cleanPath = cleanPath.substring(cleanPath.indexOf('oldbooks/'));
      } else if (cleanPath.includes('cover/')) {
        cleanPath = cleanPath.substring(cleanPath.indexOf('cover/'));
      } else if (cleanPath.includes('storge/')) {
        cleanPath = cleanPath.substring(cleanPath.indexOf('storge/'));
      }
      cleanPath = cleanPath.replace(/^[A-Za-z]:/, '').replace(/^\/+/, '');

      const apiServiceUrl = process.env.VUE_APP_API_SERVICE_URL || process.env.VUE_APP_API_URL || '';
      const apiHost = apiServiceUrl.replace(/\/api\/?$/, '').replace(/\/+$/, '');

      if (apiHost) {
        return `${apiHost}/${cleanPath}`;
      }
      return `/${cleanPath}`;
    },
    handleImageError(event) {
      if (event && event.target) {
        event.target.onerror = null;
        event.target.src = "data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='160' viewBox='0 0 120 160'%3E%3Crect width='100%25' height='100%25' fill='%23f5f2ea'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' fill='%23b5b0a5' font-family='sans-serif' font-size='14'%3ES%C3%A1ch%3C/text%3E%3C/svg%3E";
      }
    },
    formatPrice(price) {
      if (!price && price !== 0) return '0 VNĐ';
      return new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(price);
    },
    getListingStatusLabel(status) {
      const statuses = {
        0: 'Đang bán',
        1: 'Đã nhận cọc',
        2: 'Đã bán',
        3: 'Tạm ngưng',
        4: 'Đã hủy'
      };
      return statuses[status] !== undefined ? statuses[status] : 'Đang bán';
    }
  }
};
